import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-evaluation-template-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CourseEvaluationTemplateStore = {
    evaluationTemplate: Map<unknown, unknown>;
};

const initialState = (): CourseEvaluationTemplateStore => {
    return {
        evaluationTemplate: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<CourseEvaluationTemplateStore> = {
    [actionTypes.GET_EVALUATION_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evaluationTemplate: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvaluationTemplateStore>(initialState(), actionsMap);
